/* eslint-disable @typescript-eslint/no-use-before-define */
import { Component, Watch} from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import CollapseView from '@/components/CollapseView'
import SpotCheck from './components/SpotCheck.vue'
import Maintenance from './components/Maintenance'
import CallOut from './components/CallOut.vue'
import ImportButton from '@/components/ImportButton/index.vue'
import ExportButton from '@/components/ExportButton/index.vue'
import { exportDeviceTypeTemplate, importDeviceType, exportDeviceType } from '@/api/api'
import { ServiceProxy } from "@/service-proxies/app-v2/resource.service-proxies";
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import './index.less'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import CurdForm from '@/components/BaseCurd/form'

const oesp = new ServiceProxy();
const dpsp = new DeviceTypeServiceProxy()
const crsp = new CodeRuleServiceProxy()


@Component({
  components:{
    CallOut,
    SpotCheck,
    Maintenance,
    ImportButton,
    ExportButton
  }
})
export default class DeviceType extends Template {
  // 设备类型
  name = 'DeviceType'
  // tabs = ['保养项目', '点检项目']
  resizeTimer: any

  options = {
    retrieve: dpsp.pageDeviceType.bind(dpsp),
    search: dpsp.getDeviceTypeById.bind(dpsp),
    create: dpsp.createDeviceType.bind(dpsp),
    update: dpsp.updateDeviceType.bind(dpsp),
    delete: dpsp.deleteDeviceTypeByIds.bind(dpsp)
  }
  acl = {
    create: 'page_business_create_device_type',
    update: 'page_business_edit_device_type',
    delete: 'page_business_delete_device_type'
  }
  ie = true
  keywords = ''
  importFilename = '设备类型.xlsx'
  exportFilename = '设备类型.xlsx'
  selectDeviceId = ''
  selectDevice = {}
  createInitData = {}
  createdTimes = 0
  deviceTypeList = []
  disabled = false
  downloadFn = exportDeviceTypeTemplate
  importFn = importDeviceType
  exportFn = this.handleExport
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }
  async handleExport() {
    let params = {
      ids: this.selectedIds
    }
    return await exportDeviceType(params)
  }

  get tabs() {
    const tab = []
    if(this.getAcl('page_device_type_maintenance')){
      tab.push(this.$t('page_plan_maintenance_program'))
    }
     if(this.getAcl('page_device_type_spot_check')) {
      tab.push(this.$t('page_tpm_check_project_name'))
    }
     if(this.getAcl('page_device_type_call_out')) {
      tab.push(this.$t('page_andon_call_type'))
    }
    return tab
  }

  get lang() {
    return {
      create: this.$t('page_business_create_device_type'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('delete')
    }
  }

  @Watch('selectRowKey')
  handleSelectedRowKeysChange(val) {
    this.selectDeviceId = val
    this.selectDevice = this.dataSource.find(res => res.id === val)
  }

  get columns() {
    return [
      /*{
        title: this.$t('page_resource_pool_no'), dataIndex: 'order', width: 150, ellipsis: true,
        customRender: (val, record, arr) => (arr + 1)
      },*/
      { title: this.$t('page_business_fault_type_code'), dataIndex: 'code', width: 150, ellipsis: true },
      { title: this.$t('page_business_fault_type_name'), dataIndex: 'name', width: 150, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 150, ellipsis: true }
    ]
  }

  get schema() {
    return {
      // 默认图片
      photoUrl: {
        label: this.$t('page_system_default_picture'),
        type: "upload",
        props: {
          placeholder: this.$t("page_system_add_default_picture"),
        },
        // async: oesp.putFilePOST.bind(oesp),
        async: oesp.putFileUsingPOST.bind(oesp),
        customStyle: {
          marginBottom: "0px !important",
        },
      },
      codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display: this.showDrawer? "none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 128,
          disabled:this.showDrawer,
          showSearch:true,
          filterOption:this.filterOption
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.deviceTypeList,
        on: {
          change: this.handleChang
        },
      },
      // 类型编码
      code: {
        label: this.$t('page_business_fault_type_code'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_fault_type_enter_code'),
          disabled: this.disabled|| this.showDrawer
        },
        rules: [
          {
            required: !this.disabled,
            message: this.$t('page_business_fault_type_enter_code')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      // 类型名称
      name: {
        label: this.$t('page_business_fault_type_name'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_fault_type_enter_name')
          // maxLength: 48
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_fault_type_enter_name')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      remark: {
        label: this.$t('remark'),
        type: 'input',
        props: {
          placeholder: this.$t('remark_tips')
        },
        rules: [
          { max: 100, message: this.$t('page_material_warehousing_custom_more100') }
        ]
      }
    }
  }
  async getCodeRules(){
    const res = await crsp.list('DeviceTypeObject')
    let arr = []
    arr = res
    for(const k of arr) {
      this.deviceTypeList.push({
        label: k.name,
        value: k.id
      })
    }
  }
  async handleChang(val){
    if(val) {
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''}) 
    }else {
      this.disabled = false
    }
    
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    this.loading = true
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    let params = {
      keyWord: keyWords,
      query: {
        current,
        size
      }
    }

    const { records, total: t, size: s, current: c } = await fetchFn(params)
    this.selectRowKey = ''
    if (records.length) {
      this.selectRowKey = records[0].id
    }
    this.dataSource = records
    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
    this.loading = false
  }

  extraHeaderAction() {
    return [
      <import-button
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        refresh={this.refresh}
        newResFlag={true}
        style="margin-left: 8px"
      ></import-button>,
      <export-button
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        style="margin-left: 8px"
      ></export-button>
    ]
  }

  created(): void {
    this.getCodeRules()
  }
  cancelHandle(){
    this.showDialog = false
    this.disabled = false
  }

  rowClick(record) {
    return {
      on: {
        click: (event: any) => {
          this.selectRowKey = record.id
        }
      }
    }
  }

  scrollY() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }
    this.resizeTimer = setTimeout(function() {
      this.tableScrollHeight = document.querySelector('.body').clientHeight
      this.processScrollHeight = document.querySelector('.footer-container').clientHeight
      const bodyTableBody: any = document.querySelector('.body .ant-table-body')
      if (bodyTableBody) {
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
        this.tableScrollY = this.tableScrollHeight - 88
      }
      const processTableBody: any = document.querySelector('.process-table .ant-table-body')
      if (processTableBody) {
        processTableBody.style.maxHeight = (this.processScrollHeight - 150) + 'px'
      }
    }, 100)
  }

  resetFormFields(type) {
    if (type === 'add') {
      this.createInitData = { createdTimes: ++this.createdTimes }
      this.disabled = false
    } else {
      let temp = { ...this.editdata }
      this.editdata = {}
      this.editdata = { ...temp }
    }
  }
  handleColse() {
    this.showDialog = false
    this.disabled = false
  }
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }
  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          <a-popconfirm
            title={this.$t('page_resource_pool_confirm_delete')}
            onConfirm={this.deleteData}
            okText={this.$t('yes')}
            cancelText={this.$t('no')}
            disabled={this.selectedIds.length < 1}
          >
            <a-button
              v-acl={this.acl.delete}
              type="danger"
              disabled={this.selectedIds.length < 1}
            >
              {this.lang.delete}
            </a-button>
          </a-popconfirm>
          {this.ie ? this.extraHeaderAction() : null}
        <a-button
        style={{ marginLeft: "8px" }}
        disabled={this.selectedIds.length < 1}
        onClick={this.printing}
        >
        {this.$t('page_print_code')}
        </a-button>
        </div>
        <div>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: auto!important;"
            v-model={this.keywords}
          ></a-input-search>
        </div>
      </div>
    )
  }

  renderBody() {
    return (
      <div class="basecurd-body">
        <div style="height:calc(100% - 60px);overflow-y:auto;overflow-x: hidden;">
          <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            // canFixedHead={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.newColumns}
            scroll={this.scroll}
            custom-row={this.rowClick}
            rowSelection={this.showTableCheckbox ? {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            } : null}
            selectRowKey={(this.editdata && this.editdata.id) || this.selectRowKey}
          ></ml-table>
        </div>
        <a-pagination
          showQuickJumper={false}
          showSizeChanger={false}
          show-total={total => `${ this.showTotal(total) }`}
          style="float:right;margin-top:20px;margin-right:20px;"
          total={this.filters.total}
          pageSize={this.filters.size}
          current={this.filters.current}
          onChange={this.pageIndexchange}
          onShowSizeChange={this.pageIndexchange}
        ></a-pagination>
      </div>
    )
  }

  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={this.cancelHandle}
        title={this.createModalTitle}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => this.resetFormFields('add')}
          >
            {this.$t('page_calendar_reset')}
          </a-button>
          <a-button
            style="margin-right:8px"
            onClick={this.handleColse}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.createData} loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <CurdForm
          acl={{
            save: this.acl.create
          }}
          ref="_form_2"
          type="create"
          schema={this.schema}
          name={this.name}
          footer={false}
          defaultValue={this.createInitData}
        />
      </a-modal>
    )
  }

  renderDrawer() {
    return (
      <a-modal
        title={this.$t('edit')}
        visible={this.showDrawer}
        onCancel={() => (this.showDrawer = false)}
        extraStyle={{ paddingBottom: '50px' }}
      >
        <CurdForm
          acl={{
            save: this.acl.update
          }}
          ref="_form_1"
          type="edit"
          schema={this.schema}
          defaultValue={this.editdata}
          name={this.name}
          footer={false}
        />
        <div
          slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => this.resetFormFields('edit')}
          >
            {this.$t('page_calendar_reset')}
          </a-button>
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDrawer = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.updateData} loading={this.saveLoading}>
            {this.$t('save')}
          </a-button>
        </div>
      </a-modal>
    )
  }
  renderPrint() {
      return (
        <code-model 
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      )
    }

  checktabs(){
    return this.getAcl('page_device_type_maintenance') || this.getAcl('page_device_type_spot_check') || this.getAcl('page_device_type_call_out')
  }

  render() {
    return (
      <div class="device-type-main" style="height: 100%;padding: 8px 8px 8px 0;">
        {this.checktabs() ? <CollapseView tabKeys={this.tabs} y={this.scrollY}>
          <div slot="header">
            {this.renderHeader()}
          </div>
          <div slot="default" style="height: 100%">
            {this.renderBody()}
            {this.renderDialog()}
            {this.renderDrawer()}
            {this.renderPrint()}
          </div>
          <div slot="footer">
             {/*保养*/}
            <maintenance deviceId={this.selectDeviceId} selectDevice={this.selectDevice}></maintenance>
            {/*点检*/}
            <spot-check device={this.selectDevice}></spot-check>
            {/*呼叫类型*/}
            <call-out deviceTypeId={this.selectDeviceId} selectDevice={this.selectDevice}></call-out>
          </div>
        </CollapseView> : <div style="height: 100%">
          <div>
            {this.renderHeader()}
          </div>
          <div style="height: calc(100% - 38px);margin-top: 8px;">
            {this.renderBody()}
            {this.renderDialog()}
            {this.renderDrawer()}
            {this.renderPrint()}
          </div>
        </div>}
      </div>
    )
  }
}
